(() => {
  const moneyText = (html) => {
    const holder = document.createElement('template');
    holder.innerHTML = html || '';
    return holder.content.textContent;
  };
  function initProduct(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const zoom = root.querySelector('[data-dos-zoom]');
    if (zoom) zoom.addEventListener('click', () => {
      const gallery = zoom.closest('.dos-gallery');
      const active = gallery.dataset.zoomed !== 'true';
      gallery.dataset.zoomed = String(active); zoom.setAttribute('aria-pressed', String(active));
      zoom.textContent = active ? 'Reset view −' : 'Inspect +';
    });
    const variants = JSON.parse(root.querySelector('[data-dos-variants]').textContent);
    function showMedia(id) {
      if (!id || !root.querySelector(`[data-media="${id}"]`)) return;
      root.querySelectorAll('[data-media]').forEach(media => {
        const active = media.dataset.media === String(id);
        media.hidden = !active;
        if (!active) media.querySelectorAll('video').forEach(video => video.pause());
      });
      root.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
    }
    root.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    const select = root.querySelector('[data-variant-select]');
    function updateVariant(updateUrl) {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      const price = root.querySelector('[data-price]');
      if (price) price.textContent = moneyText(variant.price);
      const compare = root.querySelector('[data-compare]');
      if (compare) { compare.hidden = !variant.compare; compare.textContent = moneyText(variant.compare); }
      const sale = root.querySelector('[data-sale]');
      if (sale) sale.hidden = !variant.compare;
      const unit = root.querySelector('[data-unit-price]');
      if (unit) { unit.hidden = !variant.unit; unit.textContent = moneyText(variant.unit); }
      const add = root.querySelector('[data-add]');
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? add.dataset.addLabel : add.dataset.soldLabel; }
      const stock = root.querySelector('[data-stock]');
      if (stock) stock.textContent = variant.available ? 'Available' : 'Sold out';
      const quantity = root.querySelector('[data-quantity]');
      if (quantity) {
        quantity.min = variant.min; quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min;
      }
      showMedia(variant.media);
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    if (select) { select.addEventListener('change', () => updateVariant(true)); updateVariant(false); }
    const dialog = root.querySelector('[data-member-dialog]');
    const open = root.querySelector('[data-member-open]');
    if (dialog && open) {
      open.addEventListener('click', () => {
        dialog.showModal();
        const status = dialog.querySelector('[data-form-status]');
        const frame = dialog.querySelector('[data-signup-frame]');
        if (!frame.getAttribute('src')) {
          frame.addEventListener('load', () => { status.hidden = true; }, { once: true });
          frame.src = frame.dataset.src;
        }
        setTimeout(() => { status.hidden = true; }, 8000);
      });
      root.querySelector('[data-member-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => open.focus());
    }
  }
  function init(scope) {
    scope.querySelectorAll('[data-dos-product]').forEach(initProduct);

  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
